import { render, staticRenderFns } from "./PlantCard.vue?vue&type=template&id=191976d0&scoped=true"
import script from "./PlantCard.vue?vue&type=script&lang=ts"
export * from "./PlantCard.vue?vue&type=script&lang=ts"
import style0 from "./PlantCard.vue?vue&type=style&index=0&id=191976d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191976d0",
  null
  
)

export default component.exports